import React from "react";
import { SegmentMetric } from "utils/optimizer/ProjectOptimizer";

import styles from "./style.module.css";

const ImpliedStrategy = ({ businessConstraints, impliedBusinessConstraints, constraintTypeLabelMap, expanded }) => {
  const strategy = ((businessConstraints || [])[0] || { type: SegmentMetric.Profit }).type;
  const observed = ((impliedBusinessConstraints || [])[0] || { type: SegmentMetric.Profit }).type;

  if (strategy == observed) {
    return (
      <div
        className={styles.realityBox}
        style={expanded ? { flex: "1 1 auto", margin: "0px" } : { marginTop: "0px", maxWidth: "400px" }}
      >
        <div>
          <span>{"Your strategy and behavior are "}</span>
          <span className={styles.bold}>{"aligned"}</span>
          <span>{"."}</span>
        </div>
        <div>
          <span className={styles.bold}>{`Strategy - Maximize ${constraintTypeLabelMap[strategy]}`}</span>
        </div>
      </div>
    );
  } else {
    let direction = "increase";

    switch (strategy) {
      case SegmentMetric.Revenue:
        direction = "increase";
        break;
      case SegmentMetric.Cost:
        direction = "increase";
        break;
      case SegmentMetric.Profit:
        switch (observed) {
          case SegmentMetric.Revenue:
            direction = "decrease";
            break;
          case SegmentMetric.Cost:
            direction = "increase";
            break;
        }
    }
    const strategyDirection = ((businessConstraints || [])[0] || { direction: "min" }).direction;
    const directionText = strategyDirection === "max" ? "Limit" : "Maximize";
    const operation = strategy == SegmentMetric.Cost ? "Minimize" : "Maximize";
    const observedOperation = observed == SegmentMetric.Cost ? "Minimize" : "Maximize";

    return (
      <div
        className={styles.realityBox}
        style={
          expanded
            ? { width: "100%", margin: "0px", marginTop: "0px", backgroundColor: "#F8CD7E" }
            : { marginTop: "0px", maxWidth: "800px", margin: "0px", backgroundColor: "#F8CD7E" }
        }
      >
        <div>
          <span>{"Your strategy and behavior are "}</span>
          <span className={styles.bold} style={{ color: "red" }}>
            {"not aligned"}
          </span>
          <span>{"."}</span>
        </div>
        <div>
          <span
            className={styles.bold}
          >{`Desired Strategy: ${directionText} ${constraintTypeLabelMap[strategy]}`}</span>
        </div>
        <div>
          <span
            className={styles.bold}
          >{`Observed Strategy: ${observedOperation} ${constraintTypeLabelMap[observed]}`}</span>
        </div>
        <div style={{ display: "none" /* bring this back if wanted */ }}>
          <span>{`Aible recommends that you `}</span>
          <span className={styles.bold}>{`${direction} `}</span>
          <span>{constraintTypeLabelMap[SegmentMetric.Cost]}</span>
        </div>
      </div>
    );
  }
};

export default ImpliedStrategy;
